import script from "./adduser.vue?vue&type=script&setup=true&lang=js"
export * from "./adduser.vue?vue&type=script&setup=true&lang=js"

import "./adduser.vue?vue&type=style&index=0&id=42d47538&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d47538"]])

export default __exports__